export default __webpack_public_path__ + "static/media/WalletConnectIcon2.1115f76e.svg";